export default {
  form: {
    versions: {
      label: 'Version',
      placeholder: 'Select version',
    },
    font_family: {
      label: 'Font family',
    },
    background_color: {
      label: 'Background color',
    },
    promo_frame_primary_color: {
      label: 'Promo frame color',
    },
    promo_frame_discount_label_color: {
      label: 'Promo frame discount color',
    },
    vip_members_cta_color: {
      label: 'VIP members CTA color',
    },
    url_cta_color: {
      label: 'URL CTA color',
    },
    url_color: {
      label: 'URL color',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Select URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'QR code border color',
    },
    qr_code_background_color: {
      label: 'QR code background color',
    },
    footer_background_color: {
      label: 'Footer background color',
    },
    logo_zoom: {
      label: 'Logo size',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Failed to load sticker',
  },
};
